import usePrivateAxios from "@/common/api/usePrivateAxios";
import { useMutation } from "@tanstack/react-query";
import { ObjectiveSystemsValidationSchema } from "../schemas/objectiveSystems.schema";

interface UseCreateObjectiveSystemProps {
  onSuccess?: () => void
  onError?: (error: any) => void
}

const useCreateObjectiveSystem = ({ onSuccess, onError }: UseCreateObjectiveSystemProps) => {
  const privateAxios = usePrivateAxios();

  return useMutation({
    mutationKey: ['createMaintenanceObjectiveSystem'],
    mutationFn: (data: ObjectiveSystemsValidationSchema) => {
      const payload = {
        objective_system: {
          display_name: data.display_name,
        }
      }

      return privateAxios.post('/maintenance/objective_systems', payload);
    },
    onSuccess,
    onError,
  });
}

export default useCreateObjectiveSystem;
